import React from "react";
import TravelMap from "./components/TravelMap";
import "./App.css";

function App() {
  return (
    <div className="App">
      <TravelMap />
    </div>
  );
}

export default App;
